import { avatarUrlBuilder, TAvatar } from "@common";
import { IAvatarSettings } from "@shared";
import { AvatarPrompts, Gender, Names, Scene, VoiceTypes, Character, Avatar, AvatarsGenderId, IAvatarGender, VoiceItemTypes } from "./types";
import { useTranslation } from "react-i18next";
import { knownPromptKeys } from "../pages/Avatar/constants";

export const copyToClipboard = async (link: string): Promise<void> => {    
    try {
        await navigator.clipboard.writeText(link);
    } catch (error) {
        console.error("Failed to copy avatar link: ", error);
    }
};

export const getAvatarDefaultPrompt = (gender: Gender, name: Names, avatarPrompts: AvatarPrompts): string => {
  if (avatarPrompts[gender]) {
    return avatarPrompts[gender](name);
  }

  return avatarPrompts['male']("Иван");
};

export const removeNewlines = (str: string): string => {
  return str.replace(/\n\n/g, '\n');
};

export const formatCharactersToAvatars = (characters: Character[]): Avatar[] => {
return characters.map((el) => ({
  value: el.id,
  description: el.name,
  url: el.thumbnails?.[0]?.path,
  name: el.name,
  type: "3d",
}));
};

export const enrichAvatarsWithGender = (
  avatarsList: Avatar[],
  avatarsGender: AvatarsGenderId[],
  DEFAULT_GENDER: Gender
): IAvatarGender[] => {
  return avatarsList
    .filter((el) => avatarsGender.some((item) => item.id === el.value))
    .map((el) => {
      const found = avatarsGender.find((item) => item.id === el.value);

      const gender = found?.gender || DEFAULT_GENDER;
      const avatarRuName = found?.name || "";
      const avatarEnName = found?.enName || "";

      const namePromptKey = avatarEnName.trim().toLowerCase().replace(/\s+/g, "_") + "_prompt";
      
      const promptKey = knownPromptKeys.has(namePromptKey)
        ? namePromptKey
        : gender === "male"
          ? "male_prompt"
          : "female_prompt";

      return {
        ...el,
        gender,
        avatarRuName,
        avatarEnName,
        promptKey,
      };
    });
};

export const createPlayerSettings = (formData: TAvatar, brainId: string, avatarId: string, isNeural: boolean): IAvatarSettings => {
  const createSettingData = () => {
    return {
      initialChatEngine: brainId,
      initialTtsEngine: formData.ttsEngine,
      initialVoiceId: formData.voice,
      initialCamera: { id: "metahumans/visper" },
      initialCharacter: { id: formData.type, title: formData.type, icon: "" },
      initialScene: { id: formData.scene, title: formData.scene },
      initialCharacterPrompt: "",
      logo: "",
      language: formData.language,
      greeting: formData.greeting,
      avatarId: avatarId,
      isNeural,
    };
  }
  const settings = createSettingData();
  const settingsUrl = createSettingData();

  const avatarDeployLink = avatarUrlBuilder(settingsUrl);
  return {
    ...settings,
    avatarDeployUrl: avatarDeployLink,
  }
};